import { Phone, MessageSquare, Mail } from "lucide-react";

export function MobileContactBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary border-t border-border shadow-[0_-4px_12px_rgba(0,0,0,0.15)]">
      <div className="flex items-center justify-around h-16" data-ga-location="sticky_bar">
        <a
          href="tel:+19092559112"
          aria-label="Call SimpleTech at (909) 255-9112"
          className="flex flex-1 flex-col items-center justify-center gap-0.5 h-full text-primary-foreground hover:bg-primary/80 transition-colors"
        >
          <Phone className="w-5 h-5" strokeWidth={2} aria-hidden="true" />
          <span className="text-[10px] font-medium uppercase tracking-wide">Call</span>
        </a>
        <div className="w-px h-8 bg-primary-foreground/20" />
        <a
          href="sms:+19092559112"
          aria-label="Text SimpleTech at (909) 255-9112"
          className="flex flex-1 flex-col items-center justify-center gap-0.5 h-full text-primary-foreground hover:bg-primary/80 transition-colors"
        >
          <MessageSquare className="w-5 h-5" strokeWidth={2} aria-hidden="true" />
          <span className="text-[10px] font-medium uppercase tracking-wide">Text</span>
        </a>
        <div className="w-px h-8 bg-primary-foreground/20" />
        <a
          href="mailto:contact@simpletechhelper.com"
          aria-label="Email SimpleTech"
          className="flex flex-1 flex-col items-center justify-center gap-0.5 h-full text-primary-foreground hover:bg-primary/80 transition-colors"
        >
          <Mail className="w-5 h-5" strokeWidth={2} aria-hidden="true" />
          <span className="text-[10px] font-medium uppercase tracking-wide">Email</span>
        </a>
      </div>
    </div>
  );
}
